/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import type React from 'react'
import colors from '@sportninja/common/constants/appColors'
import { paragraphXSmall, weightMedium } from 'src/components/css'

interface StatusPillProps {
  /** Short status label, e.g. "Available". */
  label: string
  /** Leading icon, sized and coloured by the pill. */
  icon?: React.ReactNode
  /** Fill colour — an appColors status token. */
  backgroundColor: string
  /** Extra emotion styles from the call site (spacing, alignment). */
  className?: string
}

/**
 * A small filled icon + label pill for a row's status (Available, Confirmed,
 * Starting Goalie, …). Web twin of mobile's `PlayerStatusCard/SubtitlePill`, so
 * a status reads the same on both platforms.
 */
const StatusPill: React.FC<StatusPillProps> = ({
  label,
  icon,
  backgroundColor,
  className,
}) => (
  <span
    className={className}
    css={[
      pillStyle,
      css`
        background-color: ${backgroundColor};
      `,
    ]}
  >
    {icon ? <span css={iconStyle}>{icon}</span> : null}
    {label}
  </span>
)

export default StatusPill

// ---- styled ----
const pillStyle = css`
  ${paragraphXSmall}
  ${weightMedium}
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 16px;
  color: ${colors.WHITE};
  white-space: nowrap;
`
const iconStyle = css`
  display: inline-flex;
  font-size: 12px;
`
